var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AppRadioButtonsGroup',{attrs:{"options":_vm.statusOptions,"value":_vm.value,"track-by":"value","label":"label"},on:{"update":_vm.onStatusChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }